import React, { useState } from 'react';
import { Info, InsertCommentOutlined } from '@mui/icons-material';

import { FormModal, FormModalSubHeader, FormModalPaddedBody, ModalButtonRow, ModalButton } from 'components/ui/FormModal';
import { setDocumentFeedback } from "shared/services/railDocumentsApi";
import { DocumentComment } from 'shared/models/api/models';
import './Viewer.css'

type FeedbackModalProps = {
    documentId: number,
    commentMaxLength: number,
    isOpen: boolean,
    closeAction: () => void,
    submitAction: () => void
}

export const FeedbackModal = (props: FeedbackModalProps) => {
    const [commentsText, setCommentsText] = useState('');

    const answerUpdate = (event: any) => {
        let value = (event?.target?.value || '').substring(0, props.commentMaxLength) as string;
        setCommentsText(value);
    }

    const submit = () => {

        const comments: DocumentComment = { text: commentsText };

        setDocumentFeedback(props.documentId, comments).then(() => props.submitAction());
    }

    return (
        <FormModal {...props} icon={<InsertCommentOutlined />} headingText="Document feedback">
            <FormModalSubHeader>
                <div>Add a comment to this document</div>
            </FormModalSubHeader>

            <FormModalPaddedBody>

                <div className="modal-body-content-container">

                    <div className="modal-body-content-icon">
                        <Info className="info-icon" />
                    </div>

                    <div className="modal-body-content">

                        <div>Feedback is optional. Your comment will be recorded and be visible to supervisors.</div>
                        <div>If you don't want to provide feedback, please close this window</div>

                        <textarea
                            className="form-text"
                            placeholder="Type in your comments..."
                            value={commentsText}
                            maxLength={props.commentMaxLength}
                            onChange={answerUpdate} />

                        <ModalButtonRow>
                            <ModalButton onClick={props.closeAction} text="Cancel" />
                            <ModalButton onClick={submit} text="Submit" primaryButton={true} />
                        </ModalButtonRow>

                    </div>

                </div>

            </FormModalPaddedBody>

        </FormModal>
    );
}
